import { render, staticRenderFns } from "./ONavDashboardMenu.vue?vue&type=template&id=bf24b8e0&scoped=true&"
import script from "./ONavDashboardMenu.vue?vue&type=script&lang=js&"
export * from "./ONavDashboardMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf24b8e0",
  null
  
)

export default component.exports